import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";
import { screenSizes } from "@/helper";

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";
import VChart from "vue-echarts";

import { lineChart } from "./line_chart";
import { lineAreaChart } from "./line_area_chart";

interface IProps {
  data?: any;
  type?: string;
  isProfit?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ChartCustome',
  props: {
    data: {},
    type: {},
    isProfit: { type: Boolean, default: true }
  },
  setup(__props: any) {

use([
  CanvasRenderer,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
]);

const props = __props;
const option = computed(() => {
  if (props.type === `lineAreaChart`) {
    return lineAreaChart(props.data, props.isProfit).option.value;
  }
  return lineChart(props.data, props.isProfit).option.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VChart), {
    style: _normalizeStyle(
      __props.type === 'lineAreaChart'
        ? `height:${_unref(screenSizes).xs ? '400px' : '100%'};min-height:400px;`
        : 'height:100%;min-height:80px;width:100%;'
    ),
    class: "chart",
    option: option.value
  }, null, 8, ["style", "option"]))
}
}

})